import { useTranslation } from "react-i18next";

import { CONTACT_ADDRESS } from "../../constants/const";
import Button from "../../components/forms/Button/Button";
import OpenStreetMap from "../../components/ui/OpenStreetMap/OpenStreetMap";

import styles from "./styles.module.scss";

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.contactPage}>
      <div className={styles.introductionSection}>
        <div className="container">
          <h1>{t("weAreHereToHelp")}</h1>
          <div className={styles.introContentWrapper}>
            <p>{t("needToReachOut")}
              
            </p>
            <p>{t("workingDays")}
              
            </p>
            <p>{t("moreInformationAboutOurProducts")}
              
            </p>
            <a href={`tel:${CONTACT_ADDRESS}`} aria-label={`Call us at ${CONTACT_ADDRESS}`} >
              <Button btnType="secondary">{CONTACT_ADDRESS}</Button>
            </a>
          </div>
        </div>
      </div>
      <div className="container">
        <div className={styles.formSection}>
          <div className={styles.contactInfo}>
            <h3>{t("address")}:</h3>
            <p>Begijnenmeers 8, 1770 Liedekerke</p>
            <p>{t("justHeadsUp")}{" "}
               <strong>{t("sameDay")}</strong>
            </p>
          </div>
        </div>
      </div>
      <div className={styles.mapSection}>
        <div className="container">
          <OpenStreetMap />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
